import { useOne } from '@refinedev/core';
import { UploadedTemplate } from 'src/data-capture/hooks/templates/useTemplates';

type useTemplateProps = {
  companyId: string;
  templateId: string;
};

export const useTemplate = ({ companyId, templateId }: useTemplateProps) => {
  const { data, isLoading, isError, error } = useOne<UploadedTemplate>({
    resource: `admin/companies/${companyId}/templates`,
    id: templateId,
  });

  return {
    template: data?.data,
    isTemplateLoading: isLoading,
    isTemplateError: isError,
    templateError: error,
  };
};
